module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "昵称"
    },
    model: {
      value: (_vm.form.nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "nickname", $$v)
      },
      expression: "form.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "remote": "",
      "remote-method": _vm.getDistributorList
    },
    on: {
      "change": _vm.handleDistibutorChange
    },
    model: {
      value: (_vm.form.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_name", $$v)
      },
      expression: "form.distributor_name"
    }
  }, _vm._l((_vm.distributorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.inca_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "inca_id", $$v)
      },
      expression: "form.inca_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播流名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播流名称"
    },
    model: {
      value: (_vm.form.stream_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "stream_name", $$v)
      },
      expression: "form.stream_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主播状态"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "online",
      "inactive-value": "offline",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "0",
      "inactive-value": "1",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.disabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "disabled", $$v)
      },
      expression: "form.disabled"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68d6b567", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d6b567"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/anchor/add.vue
// module id = 2794
// module chunks = 0